import {matchPath, useLocation} from '@github-ui/react-router'

import {REPO_STACK_DETAIL_PATH} from '../../routes/repo-stack-detail-route'
import {REPO_STACKS_LIST_PATH} from '../../routes/repo-stacks-list-route'

export function isRepoStacksPath(pathname: string) {
  return Boolean(matchPath(REPO_STACKS_LIST_PATH, pathname) || matchPath(REPO_STACK_DETAIL_PATH, pathname))
}

/** Whether the pulls dashboard is showing the stacks list or a stack's detail page. */
export function useIsRepoStacksPage() {
  const {pathname} = useLocation()
  return isRepoStacksPath(pathname)
}
